// extracted by mini-css-extract-plugin
module.exports = {"lift":"CalendarHeader_lift__kwqiB"};